import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderApiService } from '../order-api.service';
import { NgxSpinnerService } from 'ngx-spinner';


import { Location } from '@angular/common';
import { OnActionBack } from '../../../side-nav/side-nav.component';
import { StorageService } from '../../../common/services/storage.service';
import { SideNavService } from '../../../side-nav/side-nav.service';
@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.scss']
})
export class OrderViewComponent implements OnInit, OnActionBack {
  addressSource!: { id: number; paymentAddress: { address: string; city: string; state: string; country: string; zip: string; phone: string; email: string; }; shippingAddress: { address: string; city: string; state: string; country: string; zip: string; phone: string; email: string; }; }[];
  detailProvider: any;
  orderList!: any[];
  orderId: any;
  constructor(private storage: StorageService, private _location: Location, private spinner: NgxSpinnerService, private router: Router, private route: ActivatedRoute, private orderApiService: OrderApiService, private sideNavService: SideNavService) {
    sideNavService.set(this, "Order Details",true);
    this.orderId = this.route.snapshot.paramMap.get('id');
    this.spinner.show();
     this.orderApiService.getOrderDetails(this.orderId).subscribe(
      (response: any) => {
        if (response.successCode === 0) {
          this.detailProvider = response.data;
          this.spinner.hide();
          for (const item of this.detailProvider.orderDetailDto) {
            if (item.itemType === 3) {
              const comboOptions =
                item.comboOptions !== null &&
                item.comboOptions !== undefined &&
                item.comboOptions.length > 0
                  ? JSON.parse(item.comboOptions)
                  : [];
              let totalAmt = 0;
              let totalDiscount = 0;
              for (const combo of comboOptions) {
                totalAmt += combo.price;
                totalDiscount += combo.discountAmount;
                const customizations =
                  combo.customizations !== null &&
                  combo.customizations !== undefined &&
                  combo.customizations.length > 0
                    ? JSON.parse(combo.customizations)
                    : [];
                for (const cust of customizations) {
                  totalAmt += cust.price;
                  totalDiscount += cust.discountAmount;
                }
              }
              item.fixedPrice = totalAmt
              item.discountAmount = totalDiscount;
              item.itemTotal =item.fixedPrice*item.qty-item.discountAmount;
            }
          }
        }
      },
      (error: any) => {
        console.log(error);
      }
    );

  }

  
  ngOnInit(): void {

  }
  /**
   * back to order listing page.
   * 
 */
  onActionBack(): void {
    this.storage.saveToSession('previousState', 'true');
    this.router.navigate(['/order'], { queryParams: { orderid: this.orderId, previousState: true } });
  }
 
  
  getCustomizations(item: any): any {
    return item.customizations !== null &&
      item.customizations !== undefined &&
      item.customizations.length > 0
      ? JSON.parse(item.customizations)
      : [];
  }

  getComboOptions(item: any): any {
    return item.comboOptions !== null &&
      item.comboOptions !== undefined &&
      item.comboOptions.length > 0
      ? JSON.parse(item.comboOptions)
      : [];
  }

  getOrderRemarks(order: any) {
    var remarks = "";
    if (
      order.remarks !== null &&
      order.remarks !== undefined &&
      order.remarks.length > 0
    ) {
      var rex = /\r\n|\n|\r/gm;
      remarks = "** " + order.remarks.replace(rex, "<br>");
    }
    return remarks;
  }

}
